import { useState, useEffect, useRef } from 'react';

const WHATSAPP_NUMBER = '5585999325303';

const menuItems = [
  { label: 'Home', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Experiências', href: '#diferenciais' },
  { label: 'Destinos', href: '#destinos' },
  { label: 'Intercâmbio', href: '#intercambio' },
  { label: 'Contato', href: '#contato' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    const handleNavbarEvent = (e: Event) => {
      const customEvent = e as CustomEvent;
      setIsScrolled(customEvent.detail.scrolled);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('navbar-scroll', handleNavbarEvent);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('navbar-scroll', handleNavbarEvent);
    };
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ease-out ${
          isScrolled
            ? 'bg-background-50/85 backdrop-blur-xl border-b border-background-200/40'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="flex items-center justify-between h-20">
            <a
              href="#hero"
              className="flex items-center gap-2.5 whitespace-nowrap"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/ce23925d-a222-4422-9f46-f687bc2f6079.png"
                alt="Logo"
                className={`w-10 h-10 object-contain transition-all duration-500 ${
                  isScrolled ? 'brightness-75' : 'brightness-100'
                }`}
              />
              <span
                className={`font-heading text-2xl md:text-3xl tracking-wide transition-colors duration-500 ${
                  isScrolled ? 'text-primary-800' : 'text-white'
                }`}
              >
                Ao Redor do Mundo
              </span>
            </a>

            <div className="hidden lg:flex items-center gap-1">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className={`px-4 py-2 text-sm font-light tracking-wide transition-all duration-300 rounded-lg whitespace-nowrap cursor-pointer ${
                    isScrolled
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {item.label}
                </a>
              ))}
            </div>

            <div className="flex items-center gap-4">
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Gostaria de solicitar um orçamento para minha viagem.`}
                target="_blank"
                rel="noopener noreferrer"
                className={`hidden sm:inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium tracking-wide transition-all duration-500 whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'bg-primary-500 text-white hover:bg-primary-600'
                    : 'bg-white/15 backdrop-blur-sm text-white border border-white/25 hover:bg-white/25'
                }`}
              >
                <i className="ri-whatsapp-line text-lg"></i>
                Solicitar orçamento
              </a>

              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-300 cursor-pointer ${
                  isScrolled
                    ? 'text-foreground-800 hover:bg-background-100'
                    : 'text-white hover:bg-white/10'
                }`}
                aria-label="Menu"
              >
                <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-500 ${
          isMobileMenuOpen
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none'
        }`}
      >
        <div
          className="absolute inset-0 bg-background-950/60 backdrop-blur-sm"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
        <div className="absolute top-0 right-0 w-80 h-full bg-background-50 p-8 pt-24">
          <div className="flex flex-col gap-2">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-foreground-800 font-light tracking-wide hover:bg-background-100 rounded-lg transition-all duration-300 text-lg whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Gostaria de solicitar um orçamento para minha viagem.`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium tracking-wide hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Solicitar orçamento
            </a>
          </div>
        </div>
      </div>
    </>
  );
}